import LanguageLocaleUtils from 'utils/LanguageLocale';

function roundToFirstButIgnoreZeroes(num, locale = 'en-US') {
    return num.toLocaleString(locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
        useGrouping: false
    });
}

function formatReviewCount(count) {
    const locale = LanguageLocaleUtils.getCurrentLanguageLocale();

    if (count > 999999) {
        return roundToFirstButIgnoreZeroes(count / 1000000, locale) + 'M';
    } else if (count > 999) {
        return roundToFirstButIgnoreZeroes(count / 1000, locale) + 'K';
    } else {
        return count;
    }
}

export default { formatReviewCount };
